import { CONNOTATIONS } from "@neru/types";

const connotationsArray = [
  "-transparent",
  ...Object.values(CONNOTATIONS).map((connotation) => `-${connotation}-`),
];

export const deduplicateClass = (
  defaultClassesString?: string | null,
  customClassesString?: string | null,
): string => {
  if (!customClassesString && !defaultClassesString) return "";
  if (!customClassesString) return String(defaultClassesString);
  if (!defaultClassesString) return String(customClassesString);

  const re = /\b((?:[a-zA-Z0-9\:]+-)+)\w*\b/g;

  const customClassPrefixes = new Set(
    [...customClassesString.matchAll(re)].map((match) => match[1]),
  );

  const filteredDefaultClassesString = defaultClassesString
    .split(" ")
    .filter((cls) => {
      for (const prefix of customClassPrefixes) {
        if (cls.startsWith(prefix)) return false;

        const clsBase = cls.split("-")[0];
        const prefixBase = prefix.split("-")[0];

        if (clsBase !== prefixBase) continue;

        const clsHasConnotation = connotationsArray.some((item) =>
          cls.includes(item),
        );
        const prefixHasConnotation = connotationsArray.some((item) =>
          prefix.includes(item),
        );

        if (clsHasConnotation && prefixHasConnotation) return false;
      }

      return true;
    })
    .join(" ");

  return `${filteredDefaultClassesString} ${customClassesString}`.trim();
};

export const classNames = (
  ...classes: Array<string | boolean | null | undefined>
) => classes.filter((cls) => Boolean(cls) && typeof cls === "string").join(" ");
